import React, { memo, useEffect, useState } from 'react';
import { Button, Checkbox, Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';
import { AiFillCaretDown } from "react-icons/ai";
import { FaSort } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAddEditDeleteTag, setFilterDropdown, handleFilterChange, handleSelectAll, handleOpen, setSortData, setIsAscending } from '../../reducers/contextSlice';
import { useSelector, useDispatch } from 'react-redux';

const FILTER_OPTIONS = [{ label: `On`, value: true }, { label: `Off`, value: false }, { label: `All`, value: "" }];

export const THead = memo(({ simpleFields = [], dropdownFields = [], rangeFilterFields = [], actionField = true, isSelectAll = true }) => {
    let newObject;
    let { state, pathname } = useLocation();
    const [theadTop, setTHeadTop] = useState(0);
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { filterDropdown, homeScreenSectionData, currentPageData, checkedValues, currentHomeModalKey, isAscending } = useSelector((state) => state.context)

    const sortingData = (e) => {
        dispatch(setSortData(e))
        dispatch(setFilterDropdown({}))
        dispatch(setIsAscending(!isAscending))
    };


    useEffect(() => {
        if (dropdownFields && currentHomeModalKey === 'add') {
            newObject = Object.assign({}, ...dropdownFields?.map(item => ({ [`${item.field || "is" + item.name}`]: "" })))
            if (state && state.isAdd) {
                dispatch(setFilterDropdown({ ...newObject, isActive: true }));
                dispatch(setAddEditDeleteTag(`add`));
                dispatch(handleOpen());
                navigate(pathname, {})
            } else {
                dispatch(setFilterDropdown(newObject))
            }
        }
    }, []);

    const handleFilterDropChange = (e) => {
        e.preventDefault()
        const { name, value } = e.target
        dispatch(handleFilterChange({ name, value }))
    }

    useEffect(() => {
        let mainHeader = document && document.getElementById("main-header") && document.getElementById("main-header").offsetHeight;
        let searchAndAddBar = document && document.getElementById("searchAndAddBar") && document.getElementById("searchAndAddBar").offsetHeight;
        setTHeadTop(mainHeader + searchAndAddBar);
    }, [document]);

    return (
        <thead className="bg-background-muted sticky top-0 z-10">
            <tr className="border-b border-border">
                {isSelectAll && (
                    <th className="px-4 py-3 text-left w-12">
                        <Checkbox
                            aria-label="Select all rows"
                            className="w-4 h-4 border-2 rounded border-neutral-300 checked:bg-primary-500 checked:border-primary-500 hover:border-primary-400 transition-colors"
                            checked={
                                (currentPageData?.length > 0 &&
                                    currentPageData?.length === checkedValues?.length) ||
                                (homeScreenSectionData?.length > 0 &&
                                    homeScreenSectionData?.length === checkedValues?.length)
                            }
                            onChange={(e) => dispatch(handleSelectAll({ checked: e.target.checked }))}
                        />
                    </th>
                )}
                {simpleFields &&
                    simpleFields?.map(({ name, sortable = false, field }, i) => (
                        <th 
                            key={name} 
                            className="px-4 py-3 text-left text-xs font-semibold text-text-secondary uppercase tracking-wider"
                        >
                            <div className="flex items-center gap-2">
                                <span>{name}</span>
                                {sortable && i !== simpleFields?.length - 0 && (
                                    <button 
                                        type="button" 
                                        aria-label={`Sort by ${name}`} 
                                        className="p-1 rounded hover:bg-background-hover transition-colors"
                                        onClick={() => sortingData(field)}
                                    >
                                        <FaSort className="w-3 h-3 text-text-tertiary hover:text-text-primary transition-colors" />
                                    </button>
                                )}
                            </div>
                        </th>
                    ))}
                {dropdownFields &&
                    dropdownFields?.map((_dropdown) => (
                        <th key={_dropdown.name} className="px-4 py-3 text-left">
                            {dropdownFields.includes(_dropdown) && (
                                <Menu placement="bottom-start">
                                    <MenuHandler>
                                        <button className="flex items-center gap-1.5 text-xs font-semibold text-text-secondary uppercase tracking-wider hover:text-text-primary transition-colors">
                                            {_dropdown.name}
                                            <AiFillCaretDown className="w-3 h-3" />
                                        </button>
                                    </MenuHandler>
                                    <MenuList className="min-w-[140px] p-1 border-border shadow-md">
                                        {FILTER_OPTIONS.map((_ele) => (
                                            <MenuItem
                                                name={`is${_dropdown.name}`}
                                                value={_ele.value}
                                                key={_ele.label}
                                                onClick={handleFilterDropChange}
                                                className={`
                                                    px-3 py-2 text-sm rounded-md transition-colors
                                                    ${filterDropdown[`is${_dropdown.name}`] === _ele.value 
                                                        ? 'bg-primary-500 text-white hover:bg-primary-600' 
                                                        : 'hover:bg-background-hover'
                                                    }
                                                `}
                                            >
                                                {_ele.label}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </Menu>
                            )}
                        </th>
                    ))}
                {actionField && (
                    <th className="px-4 py-3 text-left text-xs font-semibold text-text-secondary uppercase tracking-wider">
                        Actions
                    </th>
                )}
            </tr>
        </thead>
    )
})

THead.displayName = 'THead'

export default THead
